(function () {
  'use strict';

  const languages = {
        PT_BR: {
          underline: 'PT_BR',
          hyphen: 'PT-BR',
          moment: 'pt-br'
        },
        EN_US: {
          underline: 'EN_US',
          hyphen: 'EN-US',
          moment: 'en-us'
        },
        ES_ES: {
          underline: 'ES_ES',
          hyphen: 'ES-ES',
          moment: 'es'
        },
        EN_GB: {
          underline: 'EN_GB',
          hyphen: 'EN-GB',
          moment: 'en-gb'
        },
        DE_DE: {
          underline: 'DE_DE',
          hyphen: 'DE-DE',
          moment: 'de'
        },
        FR_FR: {
          underline: 'FR_FR',
          hyphen: 'FR-FR',
          moment: 'fr'
        },
        IT_IT: {
          underline: 'IT_IT',
          hyphen: 'IT-IT',
          moment: 'it'
        },
        NL_NL: {
          underline: 'NL_NL',
          hyphen: 'NL-NL',
          moment: 'nl'
        },
        PL_PL: {
          underline: 'PL_PL',
          hyphen: 'PL-PL',
          moment: 'pl'
        }
      },
      funcoes = {
        getLanguage: (id) => languages[id],
        getLanguagesObject: () => languages,
        getKeys: () => Object.keys(languages)
      };

  angular
    .module('enumModule')
    .constant('LanguagesEnum', Object.assign({}, languages, funcoes));
}());
